module.exports = __webpack_public_path__ + "img/zs_18@2x.84262184.png";